interface DependentsStepProps {
  value: number;
  onChange: (next: number) => void;
}

export function DependentsStep({ value, onChange }: DependentsStepProps) {
  return (
    <div className="space-y-3">
      <div>
        <label
          htmlFor="dependents"
          className="block text-base font-medium text-slate-900"
        >
          How many dependents do you have?
        </label>
        <p className="mt-1 text-sm text-slate-500">
          Children, relatives, or others you can claim on your return. Ages
          matter for the Child Tax Credit — we'll cover that in a later
          update. For v1 the count is informational only.
        </p>
      </div>
      <input
        id="dependents"
        type="number"
        min={0}
        max={20}
        step={1}
        inputMode="numeric"
        value={Number.isFinite(value) ? value : 0}
        onChange={(e) => {
          const raw = e.target.value;
          if (raw === '') {
            onChange(0);
            return;
          }
          const n = Math.floor(Number(raw));
          if (Number.isFinite(n)) {
            onChange(Math.max(0, Math.min(20, n)));
          }
        }}
        className="w-32 rounded-md border border-slate-300 px-4 py-2.5 text-base focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-200"
      />
      <p className="text-xs text-slate-400">0 to 20.</p>
    </div>
  );
}